var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFindBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 1.5H11.25C11.6642 1.5 12 1.83579 12 2.25V4H7V2.25C7 1.83579 7.33579 1.5 7.75 1.5ZM5.5 2.25V4H3.75C1.95507 4 0.5 5.45507 0.5 7.25V14.75C0.5 16.5449 1.95507 18 3.75 18H15.25C17.0449 18 18.5 16.5449 18.5 14.75V7.25C18.5 5.45507 17.0449 4 15.25 4H13.5V2.25C13.5 1.00736 12.4926 0 11.25 0H7.75C6.50736 0 5.5 1.00736 5.5 2.25ZM17 7.25V8.75C17 9.7165 16.2165 10.5 15.25 10.5H11.5V10C11.5 9.44771 11.0523 9 10.5 9H8.5C7.94772 9 7.5 9.44772 7.5 10V10.5H3.75C2.7835 10.5 2 9.7165 2 8.75V7.25C2 6.2835 2.7835 5.5 3.75 5.5H15.25C16.2165 5.5 17 6.2835 17 7.25ZM17 11.4891V14.75C17 15.7165 16.2165 16.5 15.25 16.5H3.75C2.7835 16.5 2 15.7165 2 14.75V11.4891C2.50515 11.8125 3.10568 12 3.75 12H7.5C7.5 12.5523 7.94772 13 8.5 13H10.5C11.0523 13 11.5 12.5523 11.5 12H15.25C15.8943 12 16.4949 11.8125 17 11.4891Z",
    fill: "#685879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindBusiness);
export default __webpack_public_path__ + "static/media/FindBusiness.7c6dccb3f6077fcb752280b00c8c2f70.svg";
export { ForwardRef as ReactComponent };